import { ProductPageLayout } from '../components/ProductPageLayout';

export function AdobeCcProPage() {
    return <ProductPageLayout productId="adobe-cc-pro" />;
}
